import type { ActualiteDTO, AgendaDTO } from '@/features/api/extranet/dto/shared'
import * as apiActualite from '@/features/services/actualite/ActualiteServices'
import * as apiAgenda from '@/features/services/agenda/AgendaServices'
import { redirectExterne } from '@/features/shared/tools/url'
import { Mounth } from '@designSystem/index'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useOnboardingStore = defineStore('onboarding', () => {
  const actualitesInt = ref<ActualiteDTO[]>()
  const agendasInt = ref<AgendaDTO[]>()

  async function loadActualites() {
    try {
      actualitesInt.value = (await apiActualite.loadActualites()) ?? []
    } catch {}
  }

  async function loadAgendas() {
    try {
      agendasInt.value = (await apiAgenda.loadAgendas()) ?? []
    } catch {}
  }

  const actualites = computed<ActualiteDTO[]>(() => {
    if (!actualitesInt.value) {
      loadActualites()
      return []
    }
    return actualitesInt.value
  })

  const agendas = computed<AgendaDTO[]>(() => {
    if (!agendasInt.value) {
      loadAgendas()
      return []
    }
    return agendasInt.value
  })

  const cardsListAgendas = computed<CardProps[]>(() => {
    return agendas.value.map<CardProps>((x) => {
      const date = new Date(x.date!)
      const dateString = Mounth[date.getMonth()]
      return {
        avatar: {
          type: 'date',
          dayAndMounth: {
            day: String(date.getDate()),
            mounth: dateString,
          },
        },
        title: x.title!,
        subtitles: [{ text: x.place!, icon: 'location' }],
        onCardClick: () => redirectExterne('https://www.akto.fr/agenda/'),
      }
    })
  })

  return {
    actualites,
    cardsListAgendas,
  }
})
